import {
  EVENTS_GET_EVENTS_REQUESTED,
} from 'consts/actionTypes';

export default () => ({
  type: EVENTS_GET_EVENTS_REQUESTED,
});
